module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel7-c6ced6ff7366c3f5fd7ea5009d09ef02.jpg";